export const SwalCustomProps = {
  customClass: {
    confirmButton: 'fibrainn-blue-btn',
  },
};
